export default "__VITE_ASSET__BOOhbv_Y__"